import faker from 'faker';
import {
  PaperVoucherValidityReference,
  PaperVoucherValidityResponse,
} from '../model';

export const getPaperVoucherValidityResponse = (): PaperVoucherValidityResponse => ({
  data: faker.helpers.randomize(Object.values(PaperVoucherValidityReference)),
});
